export function estimateReadingTime(wordCount) {
  const wordsPerMinute = 200; // calibrated to match Medium's estimation
  const minutesToRead = Math.max(
    Math.round(wordCount / wordsPerMinute),
    1, //ensures we don't get 0 minutes to read
  );
  return `${minutesToRead} min read`;
}
